var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResumeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(0, 0, 0)"
    },
    x1: 34.12856408308786,
    y1: 483.432746835898,
    x2: 34.12856408308786,
    y2: 483.432746835898
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "rgb(0, 255, 0)",
      strokeWidth: 40,
      strokeLinejoin: "round"
    },
    d: "M 21.216 478.131 L 477.47 479.403 L 478.131 153.302 L 361.092 23.623 L 21.878 21.716 L 21.216 478.131 Z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(0, 255, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 40
    },
    x1: 118.881,
    y1: 116.227,
    x2: 200,
    y2: 116.227
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(0, 255, 0)",
      strokeLinecap: "round",
      strokeWidth: 40
    },
    x1: 120.904,
    y1: 287.792,
    x2: 381.12,
    y2: 287.792
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(0, 255, 0)",
      strokeLinecap: "round",
      strokeWidth: 40
    },
    x1: 121.038,
    y1: 383.957,
    x2: 335.469,
    y2: 383.957
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeLogo);
export default __webpack_public_path__ + "static/media/resumeLogo.c0b8d29dce6dcc705ca167b075a3d3b5.svg";
export { ForwardRef as ReactComponent };